export default "__VITE_ASSET__UPqMJEJi__"